import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-map-popup-type-two',
    templateUrl: './map-popup-type-two.component.html',
    styleUrls: ['./map-popup-type-two.component.scss', '../popup.styles.scss'],
    standalone: false
})
export class MapPopupTypeTwoComponent {
  @Input() data: any = {};
}
